import Vue from 'vue'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import toastr from '../toastr'
import DcForm from '../../component/dccore-form/dcForm.vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css'
import BootstrapVue from 'bootstrap-vue'
import CompanyClientCreate from './сompanyClientCreate.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import debounce from 'lodash.debounce'

if ($('#company_form').length) {
  Vue.use(VueResource)
  Vue.use(BootstrapVue)
  new Vue({
    el: '#company_form',
    components: {
      RingLoader,
      DcForm,
      TextInput,
      Checkbox,
      CompanyClientCreate,
      Singleselect
    },
    mixins: [mixins],
    data: {
      saveBtnActive: true,
      companyId : null,
      loading: 0,
      saveCompanyClientFlag: false,
      clients: [],
      company: {
        name: null,
        manager: {},
        isActive: true
      },
      form: {
        options: {
          errors: {},
        }
      },
    },
    mounted: function () {
      if ($('#entity_id').length) {
        this.companyId = $('#entity_id').val()
        this.getCompany()
      }
    },
    methods: {
      findClients(email) {
        if (email.length) {
          this.search(email)
        }
      },
      clientSelected(client) {
        this.company.manager = client
      },
      search: debounce(function(email) {
        const url = Routing.generate('api_get_clients_email', { email })
        Vue.http.get(url).then(response => {
          this.clients = response.data
        }, response => {
          this.handleAjaxError(response)
        })
      }, 500),
      createCompany: function (redirect) {
        var url = Routing.generate('api_post_company')
        Vue.http.post(url, {
          'data': { name: this.company.name,
            manager: this.company.manager.id,
            isActive: this.company.isActive },
        }).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('company_grid'))
          } else {
            this.form.options.errors = {}
            toastr.success(Translator.trans('company.create.created'))
          }
        }, response => {
          this.handleAjaxError(response, this.form.options)
        })
      },
      updateCompany: function (redirect) {
        this.loading++
        const url = Routing.generate('api_patch_company', { id: this.companyId })

        Vue.http.patch(url, {
          'data': { name: this.company.name,
            manager: this.company.manager.id,
            isActive: this.company.isActive },
        }).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('company_grid'))
          } else {
            this.form.options.errors = {}
            toastr.success(Translator.trans('company.update.updated'))
          }
          this.loading--
        }, response => {
          this.handleAjaxError(response, this.form.options)
          this.loading--
        })
      },
      getCompany: function () {
        this.loading++
        const url = Routing.generate('api_get_company', { id: this.companyId,
          context: 'edit' })
        Vue.http.get(url).then(response => {
          this.company = response.data
          this.clients.push(this.company.manager)
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      createCompanyClient() {
        this.$refs.createCompanyClientModal.show()
      },
      saveCompanyClient(e) {
        e.preventDefault()
        this.saveCompanyClientFlag = true
      },
      savedCompanyClient() {
        this.saveCompanyClientFlag = false
        this.$refs.createCompanyClientModal.hide()
        window.location.reload(true)
      },
      companyClientSaveFailed() {
        this.saveCompanyClientFlag = false
      },
    }
  })
}
